import styles from "./lightAndLong.module.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useLayoutEffect } from "react";
import { useRef } from "react";
import DOMPurify from "dompurify";

gsap.registerPlugin(ScrollTrigger);
const LightAndLong = ({ textData, imgLoadComplate,language }) => {
  const ctnRef = useRef(null);
  const animationRef = useRef(null);
  const contentRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (imgLoadComplate) {
      ScrollTrigger.refresh();
    }
  }, [imgLoadComplate]);

  useEffect(() => {
    ScrollTrigger.matchMedia({
      // large
      "(min-width: 1025px)": function () {
        ScrollTrigger.refresh();
        const currentFrame = (index) =>
          `https://bucket.zhiyun-tech.com/detail/smq4/smq4-animation-2x/smq4-${(
            index + 1
          )
            .toString()
            .padStart(5, "0")}.jpg`;

        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        canvas.width = 3840;
        canvas.height = 2160;
        const frameCount = 160;
        const images = [];
        const craneM3 = {
          frame: 0,
        };

        for (let i = 0; i < frameCount; i++) {
          const img = new Image();
          img.src = currentFrame(i);
          images.push(img);
        }

        images[craneM3.frame].onload = render;

        function render() {
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.drawImage(images[craneM3.frame], 0, 0);
          // console.log(craneM3.frame);
        }

        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: ctnRef.current,
            start: "top top",
            pin: true,
            end: "400%",
            scrub: 1.5,
          },
        });

        // tl.fromTo(
        //   contentRef.current,
        //   {
        //     yPercent: 20,
        //   },
        //   {
        //     yPercent: 0,
        //     duration: 2,
        //   },
        //   0
        // );

        tl.to(
          craneM3,
          {
            frame: 14,
            snap: "frame",
            onUpdate: render,
            duration: 0.4,
          },
          0
        );

        tl.to(
          contentRef.current,
          {
            yPercent: -14,
            duration: 2,
          },
          0
        );

        // tl.to(
        //   ctnRef.current,
        //   {
        //     backgroundColor: "white",
        //     "--h2-color": "black",
        //     "--h5-color": "#8D9399",
        //     duration: 0.0001,
        //   },
        //   0.4
        // );

        // tl.to(animation, {
        //     ...
        //     duration: 3,
        //   },3);

        tl.to(
          craneM3,
          {
            frame: 85,
            snap: "frame",
            onUpdate: render,
            duration: 2,
          },
          3
        );

        tl.to(
          canvasRef.current,
          {
            scale: 1,
            duration: 1.5,
          },
          3
        );

        tl.to(
          contentRef.current,
          {
            yPercent: -42,
            duration: 2,
          },
          3
        );

        tl.to(
          canvasRef.current,
          {
            scale: 1.3,
            duration: 1.6,
          },
          6
        );

        tl.to(
          craneM3,
          {
            frame: 159,
            snap: "frame",
            onUpdate: render,
            duration: 2,
          },
          6
        );

        // tl.to(animation, {
        //     ...
        //     duration: 3,
        //   },6);

        tl.to(
          contentRef.current,
          {
            yPercent: -71,
            duration: 2,
          },
          6
        );

        tl.to(contentRef.current, {
          yPercent: -71,
          duration: 2,
        });
      },

      // medium
      "(min-width: 600px) and (max-width: 959px)": function () {
        // The ScrollTriggers created inside these functions are segregated and get
        // reverted/killed when the media query doesn't match anymore.
      },

      // small
      "(max-width: 1024px)": function () {
        ScrollTrigger.refresh();
        const currentFrame = (index) =>
          `https://bucket.zhiyun-tech.com/detail/smq4/smq4-animation-2x/smq4-${(
            index + 1
          )
            .toString()
            .padStart(5, "0")}.jpg`;

        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        canvas.width = 3840;
        canvas.height = 2160;
        const frameCount = 160;
        const images = [];
        const craneM3 = {
          frame: 0,
        };

        for (let i = 0; i < frameCount; i++) {
          const img = new Image();
          img.src = currentFrame(i);
          images.push(img);
        }

        images[craneM3.frame].onload = render;

        function render() {
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.drawImage(images[craneM3.frame], 0, 0);
          // console.log(craneM3.frame);
        }

        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: ctnRef.current,
            start: "top top",
            endTrigger: contentRef.current,
            end: "bottom bottom",
            scrub: 1.5,
          },
        });

        // tl.fromTo(
        //   contentRef.current,
        //   {
        //     yPercent: 20,
        //   },
        //   {
        //     yPercent: 0,
        //     duration: 2,
        //   },
        //   0
        // );

        tl.to(
          craneM3,
          {
            frame: 14,
            snap: "frame",
            onUpdate: render,
            duration: 0.4,
          },
          0
        );

        tl.to(
          craneM3,
          {
            frame: 85,
            snap: "frame",
            onUpdate: render,
            duration: 2,
          },
          3
        );

        tl.to(
          canvasRef.current,
          {
            scale: 1,
            duration: 1.5,
          },
          3
        );

        tl.to(
          canvasRef.current,
          {
            scale: 1.3,
            duration: 1.6,
          },
          6
        );

        tl.to(
          craneM3,
          {
            frame: 159,
            snap: "frame",
            onUpdate: render,
            duration: 2,
          },
          6
        );
      },

      // all
      all: function () {
        // ScrollTriggers created here aren't associated with a particular media query,
        // so they persist.
      },
    });
  }, []);
  return (
    <div className={`${styles.ctn} light-and-long-ctn`} ref={ctnRef}>
      <div className={styles.animation} ref={animationRef}>
        <canvas ref={canvasRef}></canvas>
      </div>
      <div className={styles.mask}></div>
      <div className={styles.contentBox}>
        <div className={styles.content} ref={contentRef}>
          <div className={styles.lightContent}>
            <div
              className={`${styles.lightTextBox} ${styles.textBox} light-video-text`}
            >
              <h2
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData["text10"]),
                }}
              ></h2>
              <h5
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData["text11"]),
                }}
              ></h5>

              <h6
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData["text12"]),
                }}
              ></h6>
            </div>

            <div className={styles.videoBox}>
              <video
                autoPlay
                loop
                playsInline
                muted
                preload="true"
                class="light_lightVideo__InmOm"
                poster={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-5-poster${language === 'cn' ? '' : '-en'}.jpg`}
                src={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-5${language === 'cn' ? '' : '-en'}.mp4`}
                className="light-video"
              ></video>
            </div>
          </div>

          <div className={styles.longContent}>
            <div
              className={`${styles.longTextBox} ${styles.textBox} long-video-text`}
            >
              <h2
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData["text13"]),
                }}
              ></h2>
              <h5
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData["text14"]),
                }}
              ></h5>
            </div>

            <div className={styles.videoBox}>
              <video
                autoPlay
                loop
                playsInline
                muted
                preload="true"
                class="light_lightVideo__InmOm"
                poster={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-6-poster${language === 'cn' ? '' : '-en'}.jpg`}
                src={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-6${language === 'cn' ? '' : '-en'}.mp4`}
                className="long-video"
              ></video>
            </div>
          </div>

          <div className={styles.smallContent}>
            <div
              className={`${styles.lightTextBox} ${styles.textBox} small-video-text`}
            >
              <h2
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData["text15"]),
                }}
              ></h2>
              <h5
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(textData["text16"]),
                }}
              ></h5>
            </div>

            <div className={styles.videoBox}>
              {" "}
              <video
                autoPlay
                loop
                playsInline
                muted
                preload="true"
                class="light_lightVideo__InmOm"
                poster={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-7${language === 'cn' ? '' : '-en'}.jpg`}
                src={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-7${language === 'cn' ? '' : '-en'}.mp4`}
                className="small-video"
              ></video>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LightAndLong;
